import React from 'react';

import PropTypes from 'prop-types';

import{
  VettingInfoIcon,
  VettingErrorIcon,
  VettingWhiteErrorIcon
} from 'src/Components/Common/Svg';

import './VettingInput.css';

const VettingInput = (props) => {
  const inputClasses = props.isNewForm ? [ 'vetting-new-input-box' ]:[ 'vetting-input-box' ];

  if (!props.isValid && props.isTouched) {
    inputClasses.push('vetting-input-element-invalid');
  }

  return (
    <div style={{ width: '100%' }}>
      <input
        {...props.config}
        value={props.value}
        className={inputClasses.join(' ')}
        onChange={(e) => props.updateValue(e.target.value, props.inputIdentifier)}
        onFocus={props.onFocus ? (e)=>{
          props.onFocus(e);
        } : null}
        onBlur={props.onBlur ? (e)=>{
          props.onBlur(e);
        } : null}
      />

      <div className={props.isNewForm ? 'vetting-message-container' : ''}>
        {
          props.isTouched && props.value.length === 0 && !props.isValid && props.isNewForm ? (
            <span className={`vetting-invalid-msg-wrapper ${ props.isNewForm ? 'widthFit': props.width <= 50 ? 'width200' : '' }`}>
              {props.isNewForm ? <VettingWhiteErrorIcon/> : <VettingErrorIcon />}
              <span className={props.isNewForm ? 'vetting-new-invalid-msg' : 'vetting-invalid-msg'}>
              This is a required field
              </span>
            </span>
          )

            :(!props.isValid && props.isTouched && props.value.length > 0) ?
              <span className={`vetting-invalid-msg-wrapper ${ props.isNewForm ? 'widthFit' :  props.width <= 50 ? 'width200':'' }`}>
                {props.isNewForm ? <VettingWhiteErrorIcon/> : <VettingErrorIcon />}
                <span className={props.isNewForm ? 'vetting-new-invalid-msg' : 'vetting-invalid-msg'}>

                  {props.validations.invalidMessage}
                </span>
              </span>

              :(props.note && < span className="vetting-note-wrapper">
                <VettingInfoIcon/>
                <span
                  className="vetting-note"
                >
                  {props?.note}
                </span>
              </span>)
        }
      </div>
    </div>
  );
};

VettingInput.propTypes = {
  automationidattr: PropTypes.string,
  config: PropTypes.shape({
    type: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    tabIndex: PropTypes.string
  }),
  inputIdentifier: PropTypes.string,
  isTouched: PropTypes.bool,
  isValid: PropTypes.bool,
  note: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  updateValue: PropTypes.func,
  validations: PropTypes.shape({
    type: PropTypes.string,
    required: PropTypes.bool,
    invalidMessage: PropTypes.string
  }),
  value: PropTypes.string,
  width: PropTypes.number,
  isNewForm: PropTypes.bool
};

export default VettingInput;